import { useMemo, useState } from "react";
import {
  List,
  NumberField,
  TextField,
  WrapperField,
  DatagridConfigurable,
  WithRecord,
  DateField,
  FunctionField,
  BulkDeleteWithConfirmButton,
  usePermissions,
} from "react-admin";
import SalesmanTargetAddDialog from "../../components/salesmanTargets/create/SalesmanTargetAddDialog";
import SalesmanTargetEditDialog from "../../components/salesmanTargets/edit/SalesmanTargetEditDialog";
import salesmanTargetFilterList from "../../components/salesmanTargets/filter/salesmanTargetFilterList";
import EditBtn from "../../components/editBtn/EditBtn";
import TableListActions from "../../components/tableListActions/TableListActions";

const SalesmanTargetList = () => {
  const { permissions } = usePermissions();
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [recordId, setRecordId] = useState();

  const handleClickOpenAdd = () => {
    setOpenAdd(true);
  };
  const handleClickOpenEdit = (recId) => () => {
    setRecordId(recId);
    setOpenEdit(true);
  };
  const list = useMemo(
    () => (
      <List
        empty={false}
        actions={
          <TableListActions
            createHandler={handleClickOpenAdd}
            exporter={false}
            createPermission="create_salesman_target"
          />
        }
        filters={salesmanTargetFilterList(permissions)}
        queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
      >
        <DatagridConfigurable
          bulkActionButtons={<BulkDeleteWithConfirmButton />}
        >
          {permissions && permissions.update_company ? (
            <TextField label="mine.label.company" source="company.alias" />
          ) : null}
          <FunctionField
            label="Salesman"
            render={(record) =>
              `${record.salesman.code} | ${record.salesman.name}`
            }
          />
          <NumberField label="Target box" source="target" />
          <DateField
            source="start_date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <DateField
            source="end_date"
            options={{
              year: "numeric",
              month: "short",
              day: "2-digit",
            }}
          />
          <WrapperField label="mine.label.actions" textAlign="center">
            <WithRecord
              label="author"
              render={(record) => {
                return <EditBtn editHandler={handleClickOpenEdit(record.id)} />;
              }}
            />
          </WrapperField>
        </DatagridConfigurable>
      </List>
    ),
    [permissions]
  );
  return (
    <>
      {list}
      <SalesmanTargetAddDialog open={openAdd} setOpen={setOpenAdd} />
      <SalesmanTargetEditDialog
        open={openEdit}
        setOpen={setOpenEdit}
        recordId={recordId}
      />
    </>
  );
};

export default SalesmanTargetList;
